<template>
  <v-layout>
    <div class="padding-container-sm">
      <v-page-header>
        <span slot="header">
          <div class="row">
            <div class="col">
              <b-input-group size="md">
                <b-input-group-text
                  slot="append"
                  class="bg-white"
                >
                  <strong><i class="icon ion-md-search" /></strong>
                </b-input-group-text>
                <b-form-input
                  class="border-right-0"
                  :value="filter.searchValue"
                  placeholder="Search for patient , ID"
                  @keyup.enter.native="onSearchText"
                  @blur.native="onSearchText"
                />
              </b-input-group>
            </div>
          </div>
        </span>
      </v-page-header>
      <v-table
        :options="tableProps"
        :total-count="Number(totalCount)"
        :data="delegates"
      >
        <template
          slot="name"
          slot-scope="slotProps"
        >
          <div class="align-items-center d-flex patient-name-content justify-content-center">
            <img
              :src="require(`@/assets/image/${
                slotProps.data.datum && slotProps.data.datum.gender === 'male' ?
                  'boy':
                  'girl'
              }.svg`)"
              width="35"
              height="35"
              :alt="slotProps.data.datum.first_name"
              v-b-tooltip.hover
              :title="slotProps.data.datum.first_name"
            >
            <div
              class="d-flex flex-column justify-content-center align-items-center"
              v-if="slotProps"
            >
              <span>
                {{ slotProps.data.datum.first_name | capitalizefirst }}
                {{ slotProps.data.datum.last_name | capitalizefirst }}
              </span>
              <span v-if="permissions.patientmessage && permissions.patientmessage.view" class="btn btn-link" @click="redirectToMessage(slotProps.data.datum.mr_id)">
                Send Message
              </span>
            </div>
          </div>
        </template>
        <template
          slot="delegates"
          slot-scope="slotProps"
        >
          <template
            v-if="slotProps.data.datum.delegate.length === 1 &&
            slotProps.data.datum.delegate[0].is_deleted"
          >
            <span>No CareGivers for this patient</span>
          </template>
          <div
            class="d-flex flex-row justify-content-around delegatesCell"
            v-for="delegate in slotProps.data.datum.delegate"
            :key="delegate.patient_delegate_id"
          >
            <div
              v-if="!delegate.is_deleted"
              class="d-flex flex-column justify-content-center align-items-center p-2 col"
            >
              <span>
                <b>
                  {{ delegate.first_name | capitalizefirst }}
                  {{ delegate.last_name | capitalizefirst }}
                </b>
              </span>
              <span>{{ delegate.mobile_no }}</span>
              <span
                @click="confirmAndRemoveDelegate(delegate, slotProps.data.datum)"
                class="btn btn-link text-danger"
                v-if="delegate.is_active"
              >
                Remove CareGiver
              </span>
              <span
                @click="confirmAndRemoveDelegate(delegate, slotProps.data.datum)"
                class="btn btn-link text-danger"
                v-else
              >
                Delete request
              </span>
            </div>
          </div>
        </template>
      </v-table>
    </div>
    <v-loader :isLoading="isLoading" />
  </v-layout>
</template>

<script>
import VTable from '@/components/table/index.vue';
import VLayout from '@/layouts/Default.vue';
import VPageHeader from '@/components/pageheader/PageHeader.vue';
import VLoader from '@/components/loader/index.vue';
import message from '@/constants/_message';
import { mapGetters } from 'vuex';

export default {
  name: 'Delegates',
  components: {
    VTable,
    VLayout,
    VPageHeader,
    VLoader
  },
  data() {
    return {
      filter: {
        status: 'All',
        searchValue: '',
        limit: 10,
        pageNo: 1,
        alertDate: this.getFormattedDate()
      },
      tableProps: {
        columns: [
          {
            headerCellProps: {
              class: 'header-cell'
            },
            cellProps: {
              class: 'text-left'
            },
            cellSlot: {
              name: 'name'
            },
            dataKey: 'first_name',
            dataType: String,
            label: 'Patient name'
          },
          {
            headerCellProps: {
              class: 'header-cell'
            },
            cellProps: {},
            dataKey: 'mr_id',
            dataType: String,
            label: 'Patient ID'
          },
          {
            headerCellProps: {
              class: 'header-cell'
            },
            cellSlot: {
              name: 'delegates'
            },
            cellProps: {
              class: 'p-0'
            },
            dataKey: 'delegate',
            dataType: String,
            label: 'CareGiver Contact'
          }
        ],
        enableSelect: false,
        onPageChange: this.onPageChange,
        page: 1,
        rowProps: {},
        rowsPerPage: 10,
        title: 'All caregivers'
      }
    };
  },
  computed: {
    ...mapGetters({
      delegates: 'delegate/getDelegates',
      isLoading: 'delegate/getIsLoading',
      totalCount: 'delegate/getTotalCount',
      permissions: "auth/getModulePermissions",
    })
  },
  watch: {
    filter: {
      handler: 'fetchDelegates',
      immediate: true
    }
  },
  methods: {
    fetchDelegates() {
      this.$store.dispatch('delegate/getDelegates', this.filter);
    },
    onPageChange(pageNo, rowsPerPage) {
      this.tableProps.page = pageNo;
      this.filter = {
        ...this.filter,
        pageNo,
        limit: rowsPerPage
      };
    },
    onSearchText(event) {
      this.filter = {
        ...this.filter,
        searchValue: event.target.value
      };
    },
    confirmAndRemoveDelegate(delegate, patient) {
      const config = {
        removeDelegate: {
          title: 'Remove CareGiver',
          message: `Do you want to remove this CareGiver (${
            delegate.first_name
          } ${delegate.last_name})?`,
          successMessage: message.DELEGATE_REMOVED,
          failureMessage: message.DELEGATE_NOT_REMOVED
        },
        deleteRequest: {
          title: 'Delete CareGiver request',
          message: 'Do you want to delete this request ?',
          successMessage: message.DELEGATE_REQUEST_DELETED,
          failureMessage: message.DELEGATE_REQUEST_NOT_DELETED
        }
      };
      const action = delegate.is_active ? 'removeDelegate' : 'deleteRequest';
      const content = {
        title: config[action].title,
        message: config[action].message
      };
      this.conFirmAlert(
        content,
        () => {
          this.$store.dispatch('delegate/updateDelegate', {
            data: {
              is_deleted: true,
              delegate_id: delegate.delegate_id,
              is_patient: true,
              patient_id: delegate.patient_id
            },
            successMessage: config[action].successMessage,
            failureMessage: config[action].failureMessage,
            patient
          });
        },
        () => {}
      );
    },
    redirectToMessage(mrId) {
      const data = { mrId, isSelectedPatient: true };
      this.$store.dispatch('patient/setPatientDataToMsg', data);
      this.$router.push({ name: 'message.index' });
    },
  }
};
</script>

<style lang="scss" scoped>
  @import "./style.scss";
  @import "@/views/Alert/style.scss";
</style>
